export class MediaUseCommandModel {
    public mediaMediaUseId: string;
    public mediaUseCode: string;
}